import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import {
  fontSize,
  fontWeight,
  spacing,
  mediaMax,
} from 'presentations/views/styles';
import BlogPageTemplate from 'presentations/views/components/templates/ResourcePageTemplate';
import { useCareerPage } from './hooks';
import BlogShareList from 'presentations/views/components/organisms/ResourceShareList';
import CareerContent from 'presentations/views/components/organisms/CareerContent';
import Button from 'presentations/views/components/atoms/Button';

import { CareerItem } from 'presentations/api/schema/contents';
import AboutHeader from 'presentations/views/components/organisms/AboutHeader';
import { useMemo } from 'react';
import { formPath } from 'presentations/routes/path';

interface Props {
  item: CareerItem;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const { state, actions } = useCareerPage({
    item: props.item,
  });
  const applyUrl = useMemo(() => {
    return formPath('jicoohq', 'y5-LqDoTUQA7');
  }, []);

  return (
    <BlogPageTemplate header={<AboutHeader />}>
      <>
        <Container>
          <MainContent>
            <CareerContent item={props.item} />
            <ApplyButtonContainer>
              <ApplyButton size="large" color="primary" href={applyUrl}>
                {t('apply')}
              </ApplyButton>
            </ApplyButtonContainer>
            <ShareContainer>
              <ShareTitle>{t('share')}</ShareTitle>
              <ShareIconContainer>
                <BlogShareList
                  shareTitle={props.item.title}
                  shareUrl={state.shareUrl}
                  direction="row"
                />
              </ShareIconContainer>
            </ShareContainer>
          </MainContent>
        </Container>
      </>
    </BlogPageTemplate>
  );
}

const Container = styled.div`
  letter-spacing: 0.05em;
  display: flex;
  justify-content: center;
  padding: ${spacing(48)} 0;
  ${mediaMax.desktop} {
    display: block;
    padding: ${spacing(32)} 0;
  }
`;
const MainContent = styled.div`
  width: 672px;
  ${mediaMax.desktop} {
    margin: 0 auto;
  }
  ${mediaMax.tablet} {
    width: 100%;
    padding: 0 ${spacing(12)};
    margin: 0;
  }
`;
const ShareContainer = styled.div``;

const ShareTitle = styled.div`
  margin: 0 0 ${spacing(20)} 0;

  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(20)};
  line-height: 150%;
  text-align: center;

  ${mediaMax.tablet} {
    margin: 0 0 ${spacing(24)} 0;
    font-size: ${fontSize(13)};
  }
`;

const ShareIconContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: center;
`;

const ApplyButtonContainer = styled.div`
  margin-bottom: ${spacing(96)};

  ${mediaMax.tablet} {
    margin-bottom: ${spacing(72)};
  }
`;
const ApplyButton = styled(Button)`
  width: 100%;
`;
